import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Content, Info } from './error-msg.styled';

const errors = {
  RPCItemExists: 'ГРЗ уже в сером списке',
  'Уже существует': 'Уже существует',
  'Item not found': 'Элемент не найден',
  duplicate: 'СО уже существует',
  'Wrong value type': 'Неверное значение',
  'Пароль менее 8 символов ': 'Пароль менее 8 символов',
};
const getError = (err) => {
  return errors[err] ?? 'Ошибка сохранения';
};

export const ErrorMsg = (props) => {
  const { error, message, ...rest } = props;
  const { t } = useTranslation();

  if (!error && !message) {
    return null;
  }

  if (message === 'Отсутсвует пароль') {
    return null;
  }

  const getErrorMessage = () => {
    if (Array.isArray(error)) {
      let out = '';
      error.forEach((el) => {
        if (out) {
          out += ', ';
        }
        out += el.param + ': ' + getError(el.message);
      });
      return out;
    } else {
      return getError(error);
    }
  };

  const msg = message ? message : getErrorMessage();
  // console.log('🚀 ~ ErrorMsg ~ msg:', props);

  return (
    <Content {...rest}>
      <img src="/images/error-triangle-icon.png" width={22} height={20} alt="" />
      <Info>{t('errors.' + msg)}</Info>
    </Content>
  );
};

ErrorMsg.propTypes = {
  theme: PropTypes.string,
  error: PropTypes.any,
  message: PropTypes.string,
};
